import { GetAppRounded } from "@mui/icons-material";
import * as FileSaver from "file-saver";
import * as XLSX from "sheetjs-style";
import { Tutorial } from "provider/TutorialProvider";
function ExcelExport() {
  const excelData = [
    {
      name: "Ram",
      email: "ram@gmail.com",
      phoneNo: "9098459999",
    },
    {
      name: "Shyam",
      email: "shyam@gmail.com",
      phoneNo: "9997645399",
    },
  ];
  const fileName = "Sample_excel_sheet";
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const { tutorialSteps, nextStep } = Tutorial();
  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
    nextStep();
  };

  return (
    <button
      data-step={tutorialSteps.INPUT_FILE}
      className="bg-yellow-50 border rounded-l-none border-yellow-300 hover:bg-yellow-100 px-4 py-1.5 rounded-lg flex items-center text-yellow-700 text-sm font-medium"
      onClick={exportToExcel}
      style={{ zIndex: 9999, position: "relative" }}
    >
      <span className="mr-2">Download Sample</span>
      <GetAppRounded style={{ width: "18px", height: "18px" }} />
    </button>
  );
}

export default ExcelExport;
